import Request from './js/request';

export default { Request };
